import { render, staticRenderFns } from "./DatatableSearch.vue?vue&type=template&id=2b4432ec&"
import script from "./DatatableSearch.vue?vue&type=script&lang=js&"
export * from "./DatatableSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports